function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16.1,
  cy: 9.8,
  r: 8.4
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6 32.7c0-8-6.5-14.6-14.6-14.6S1.5 24.7 1.5 32.7h29.1z"
});

var SvgUserAccount = function SvgUserAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon-profile",
    viewBox: "0 0 32.2 34.4"
  }, props), _ref, _ref2);
};

export default SvgUserAccount;